var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.653 3.12306C26.3493 1.89371 25.4545 0.925644 24.318 0.597096C22.2586 -3.84545e-08 13.9999 0 13.9999 0C13.9999 0 5.74125 -3.84545e-08 3.68172 0.597096C2.54534 0.925644 1.6504 1.89371 1.34668 3.12306C0.794922 5.35112 0.794922 9.99998 0.794922 9.99998C0.794922 9.99998 0.794922 14.6487 1.34668 16.8771C1.6504 18.1063 2.54534 19.0744 3.68172 19.4031C5.74125 20 13.9999 20 13.9999 20C13.9999 20 22.2586 20 24.318 19.4031C25.4545 19.0744 26.3493 18.1063 26.653 16.8771C27.2049 14.6487 27.2049 9.99998 27.2049 9.99998C27.2049 9.99998 27.2049 5.35112 26.653 3.12306Z",
    fill: "#C6CBD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2988 14.2166L18.2015 9.99599L11.2988 5.77502V14.2166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGrey);
export default __webpack_public_path__ + "static/media/youtubeGrey.57e16e954b79c2e59156c32f6ce81ee0.svg";
export { ForwardRef as ReactComponent };